import api from './api';
import type { InventoryValuation } from '../types/venue';

const base = (venueId: string) => `/admin/venue/${venueId}/inventory/valuation`;

export interface ValuationParams {
  locationId?: string;
}

const inventoryValuationService = {
  getValuation: async (
    venueId: string,
    params: ValuationParams = {},
  ): Promise<InventoryValuation> => {
    const p: Record<string, unknown> = {};
    if (params.locationId) p.locationId = params.locationId;
    const response = await api.get(base(venueId), { params: p });
    return response.data;
  },
};

export default inventoryValuationService;
